export const passwordRequirements = (password) => {
  const passwordRequirements = [
    { title: 'At least 8 characters', checked: password.length > 7 },
    { title: '1 uppercase character', checked: password.search(/[A-Z]/) > -1 },
    { title: '1 lowercase character', checked: password.search(/[a-z]/) > -1 },
    { title: '1 number', checked: password.search(/[0-9]/) > -1 },
  ]

  return passwordRequirements
}
